import axios from "axios";

const token_payment = process.env.VUE_APP_TOKEN_PAYMENT;

// Cliente dedicado al API de pagos (VUE_APP_CHECKOUT_URL, VUE_APP_SUBSCRIPTION_URL,
// VUE_APP_STRIPE_API_URL). No usa baseURL: siempre se le pasan URLs absolutas.
// Lleva su propio Bearer para no mezclarse con el token de sesion de Odoo.
const axiosPayment = axios.create();

axiosPayment.defaults.headers.common["Authorization"] = `Bearer ${token_payment}`;

// Headers para peticiones que no usan axios (fetch).
const paymentHeaders = (headers = {}) => ({
  Authorization: `Bearer ${token_payment}`,
  ...headers,
});

// El API de pagos responde la URL de Stripe en distintas formas segun el
// endpoint; si el backend contesto con un redirect, la URL final queda en
// responseURL (solo sirve si es distinta a la que se pidio).
const getCheckoutUrl = (response, requestedUrl) => {
  const url =
    response?.data?.data?.url ||
    response?.data?.url ||
    response?.data?.payload?.url ||
    null;

  if (url) return url;

  const responseURL = response?.request?.responseURL;
  return responseURL && responseURL !== requestedUrl ? responseURL : null;
};

export { axiosPayment, paymentHeaders, getCheckoutUrl };
